var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ams-select-table',{attrs:{"ams_api_path":_vm.ams_api_path,"ams_type":_vm.ams_type,"ams_fields":_vm.ams_fields,"pre_selected_items":_vm.pre_selection,"select_mode":_vm.mode_selection},on:{"selectedRows":_vm.selectRows}})}
var staticRenderFns = []

export { render, staticRenderFns }